const styles = theme => ({
    UploadContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px 10px'
    },
    header3: {
        width: '80%',
        padding: '10px 20px',
        backgroundColor: 'rgba(94, 112, 247, 1)',
        color: 'white',
        display: 'flex',
        justifyContent: 'center'
    }
});

export default styles;